export const TicketStatus = {
  New: 'new',
  Open: 'open',
  Resolved: 'resolved',
} as const;
